@if (searchFacets != null) {
  <div class="facet-search">
    <div class="facet-container">
      <!-- Original Facets (Alphabetical) -->
      @for (facet of getOriginalFacets(); track facet) {
        @if (facet.Values !== null && facet.Values.length > 0) {
          <div class="facet-dropdown">
            <div class="dropdown">
              <button class="btn btn-outline-secondary btn-sm dropdown-toggle facet-button" type="button"
                [id]="'facetDropdown_' + facet.FieldName"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                [class.active]="hasSelectedValues(facet.FieldName)">
                <span class="facet-label">{{ 'COMPONENTS.COMMON.SEARCH.FACET.HEADER.' + facet.FieldName.toUpperCase() | translate }}</span>
                @if (getSelectedCount(facet.FieldName) > 0) {
                  <span class="badge ms-1">{{ getSelectedCount(facet.FieldName) }}</span>
                }
              </button>
              <div class="dropdown-menu facet-dropdown-menu" [attr.aria-labelledby]="'facetDropdown_' + facet.FieldName">
                @for (facetValue of facet.Values; track facetValue) {
                  <div class="facet-value dropdown-item-text" (click)="$event.stopPropagation()">
                    <label class="mb-0">
                      <div class="facet-checkbox-wrapper">
                        <input type="checkbox"
                          [checked]="facetIndex(facet.FieldName, facetValue.Value) >= 0"
                          (change)="toggleFacet($event, facet.FieldName, facetValue.Value)" />
                          <span class="facet-label-text">{{ getValueTranslation(facetValue.Value) | translate }}</span>
                        </div>
                        <span class="facet-count text-muted">({{ facetValue.Count }})</span>
                      </label>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        <!-- Separator between original and new facets -->
        @if (hasNewFacets()) {
          <div class="facet-separator"></div>
        }
        <!-- New Facets (Alphabetical) -->
        @for (facet of getNewFacets(); track facet) {
          @if (facet.Values !== null && facet.Values.length > 0) {
            <div class="facet-dropdown">
              <div class="dropdown">
                <button class="btn btn-outline-secondary btn-sm dropdown-toggle facet-button" type="button"
                  [id]="'facetDropdown_' + facet.FieldName"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  [class.active]="hasSelectedValues(facet.FieldName)">
                  <span class="facet-label">{{ 'COMPONENTS.COMMON.SEARCH.FACET.HEADER.' + facet.FieldName.toUpperCase() | translate }}</span>
                  @if (getSelectedCount(facet.FieldName) > 0) {
                    <span class="badge bg-primary ms-1">{{ getSelectedCount(facet.FieldName) }}</span>
                  }
                </button>
                <div class="dropdown-menu facet-dropdown-menu" [attr.aria-labelledby]="'facetDropdown_' + facet.FieldName">
                  @for (facetValue of facet.Values; track facetValue) {
                    <div class="facet-value dropdown-item-text" (click)="$event.stopPropagation()">
                      <label class="mb-0">
                        <div class="facet-checkbox-wrapper">
                          <input type="checkbox"
                            [checked]="facetIndex(facet.FieldName, facetValue.Value) >= 0"
                            (change)="toggleFacet($event, facet.FieldName, facetValue.Value)" />
                            <span class="facet-label-text">{{ getValueTranslation(facetValue.Value) | translate }}</span>
                          </div>
                          <span class="facet-count text-muted">({{ facetValue.Count }})</span>
                        </label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          }
          <!-- Separator before clear all button -->
          @if (hasMultipleSelections()) {
            <div class="facet-separator"></div>
          }
          <!-- Clear All Button -->
          @if (hasMultipleSelections()) {
            <button
              class="btn btn-sm btn-outline-secondary reset-all-button"
              type="button"
              (click)="clearAll()">
              <i class="fas fa-times"></i>
              <span class="ms-1">{{ 'COMPONENTS.COMMON.SEARCH.FACET.CLEAR-ALL' | translate }} ({{ getTotalSelectedCount() }})</span>
            </button>
          }
        </div>
      </div>
    }